<template>
<div class="chapter">
<div class="inner_page">
<div id="Dedication">
<p class="ded-title">Dedication</p>
<p class="ded-center">This book is dedicated to my much-loved sister Stephanie</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_Dedication.vue?455577ba